module.exports = __webpack_public_path__ + "static/media/icon_glass_products.2ce19f82.svg";